module.exports = __webpack_public_path__ + "static/media/albums.c894f9cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/photography/albums.jpg
// module id = 733
// module chunks = 0